"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
require("core-js/modules/esnext.string.replace-all.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.number.to-fixed.js");
var _formElements = require("@evidation/form-elements");
var _react = _interopRequireWildcard(require("react"));
var _utils = require("./utils");
var _reactI18next = require("react-i18next");
var _LanguageContext = require("../contexts/LanguageContext");
var _ui = require("@evidation/ui");
var _excluded = ["labelStyle", "input", "inputStyle", "label", "config", "disabled", "t", "error", "touched", "meta"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var handleUserInput = function handleUserInput(event, onChange) {
  var _event$nativeEvent;
  var value = event.target.value;
  var data = (_event$nativeEvent = event.nativeEvent) === null || _event$nativeEvent === void 0 ? void 0 : _event$nativeEvent.data;
  var regex = /^[0-9.]*$/;
  if (!regex.test(value)) {
    if (data) {
      onChange(String(value).replaceAll(data, ''));
    }
  } else {
    onChange(value);
  }
};
var HeightSelector = function HeightSelector(_ref) {
  var labelStyle = _ref.labelStyle,
    input = _ref.input,
    inputStyle = _ref.inputStyle,
    label = _ref.label,
    _ref$config$required = _ref.config.required,
    required = _ref$config$required === void 0 ? false : _ref$config$required,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    t = _ref.t,
    error = _ref.error,
    touched = _ref.touched,
    meta = _ref.meta,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var feetText = "".concat(t('components.fieldHeight.feet'));
  var inchText = "".concat(t('components.fieldHeight.inch'));
  var placeholder = t('components.select.placeholder');
  var _useState = (0, _react.useState)({
      ft: undefined,
      inch: undefined
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    imperialHeightValue = _useState2[0],
    setImperialHeightValue = _useState2[1];

  // needed to include previous contributions in submitted data after go-back
  (0, _react.useEffect)(function () {
    var name = input.name,
      value = input.value;
    var inch = '';
    var ft = '';
    if (value !== undefined && (0, _typeof2["default"])(value) === 'object') {
      inch = value[name].inch;
      ft = value[name].ft;
    } else if (Number(value) !== undefined && Number(value) > 0) {
      ft = Math.floor(value / 12);
      inch = rest.imperial_inches_decimal_places !== undefined && String(rest.imperial_inches_decimal_places).length ? Number(value % 12).toFixed(Number(rest.imperial_inches_decimal_places)) : value % 12;
    }
    setImperialHeightValue({
      ft: ft,
      inch: inch
    });
    input.onChange({
      ft: ft,
      inch: inch
    });
  }, []);
  var handleInChange = function handleInChange(value) {
    var inchValue = String(value).length > 0 ? value : '';
    setImperialHeightValue(function (currentState) {
      return _objectSpread(_objectSpread({}, currentState), {}, {
        inch: inchValue
      });
    });
    input.onChange(_objectSpread(_objectSpread({}, imperialHeightValue), {}, {
      inch: inchValue
    }));
  };
  var handleFtChange = function handleFtChange(value) {
    var ftValue = String(value).length > 0 ? value : '';
    setImperialHeightValue(function (currentState) {
      return _objectSpread(_objectSpread({}, currentState), {}, {
        ft: ftValue
      });
    });
    input.onChange(_objectSpread(_objectSpread({}, imperialHeightValue), {}, {
      ft: ftValue
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_ui.Flex, {
    items: "center",
    fullWidth: true,
    spaceX: 4
  }, /*#__PURE__*/_react["default"].createElement(_formElements.NumberInput, {
    className: "height ".concat((0, _utils.constructFieldClassname)(meta)),
    id: "t-height_ft",
    name: "t-height_ft",
    "data-test-id": "t-height_ft",
    inputStyle: inputStyle,
    label: feetText,
    position: "inline-label-after",
    onChange: function onChange(event) {
      return handleUserInput(event, handleFtChange);
    },
    value: imperialHeightValue.ft,
    disabled: disabled,
    convertValuesToStrings: false,
    initialValue: placeholder
  }), /*#__PURE__*/_react["default"].createElement(_formElements.NumberInput, {
    className: "height ".concat((0, _utils.constructFieldClassname)(meta)),
    id: "t-height_inch",
    name: "t-height_inch",
    label: inchText,
    "data-test-id": "t-height_inch",
    position: "inline-label-after",
    inputStyle: inputStyle,
    onChange: function onChange(event) {
      return handleUserInput(event, handleInChange);
    },
    value: imperialHeightValue.inch,
    disabled: disabled,
    convertValuesToStrings: false,
    initialValue: placeholder
  }));
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)(_LanguageContext.curiousPandaNamespace)(HeightSelector);